import { ChangeDetectionStrategy, Component, input, signal, Input, OnChanges } from "@angular/core";
import { Router } from "@angular/router";

import { RouteEnum } from "src/app/shared/enums";

import { ISettingGroup } from "@shared/interfaces";

@Component({
  standalone: false,
  selector: "app-settings-list",
  templateUrl: "./settings-list.component.html",
  styleUrls: ["./settings-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsListComponent implements OnChanges {
  @Input()
  public isShowDescription = false;

  public allSettingGroups = input.required<ISettingGroup[]>();

  public filteredSettingGroups = signal<ISettingGroup[]>([]);

  public searchText: string = "";

  constructor(private router: Router) {}

  public ngOnChanges(): void {
    this.setFilteredSettingGroups();
  }

  public onSearchChanged = (searchText: string): void => {
    this.searchText = searchText;
    this.setFilteredSettingGroups();
  };

  private setFilteredSettingGroups = (): void => {
    this.filteredSettingGroups.set([]);
    for (const settingGroup of this.allSettingGroups()) {
      if (!settingGroup.isHidden) {
        const filteredSettingGroup: ISettingGroup = {
          ...settingGroup,
          settings: [],
        };

        for (const setting of settingGroup.settings) {
          if (
            !setting.isHidden &&
            (!this.searchText ||
              setting.title.toLowerCase().includes(this.searchText.toLowerCase()))
          ) {
            filteredSettingGroup.settings.push({ ...setting });
          }
        }
        if (filteredSettingGroup.settings.length) {
          this.filteredSettingGroups().push(filteredSettingGroup);
        }
      }
    }
  };

  public onGoToRoute = async (route: RouteEnum): Promise<void> => {
    await this.router.navigate([`/${route}`]);
  };
}
